import Box from '@/primitives/Box'
import Text from '@/primitives/Text'
import FlexV2 from '@/primitives/FlexV2'
import Icon from '@/primitives/Icon'
import { Tooltip } from 'react-tooltip'
import Strings from '../../Strings'

const MetricValue = ({ label, value, min, max, unit = '' }) => {
  const formattedValue = !isNaN(value) ? (+value).toFixed(1) : '—'
  const formattedMin = !isNaN(min) ? (+min).toFixed(1) : '—'
  const formattedMax = !isNaN(max) ? (+max).toFixed(1) : '—'
  const baseTooltipId = `tooltip-${label.replace(/\s+/g, '-').toLowerCase()}`
  const minTooltipId = `min-${baseTooltipId}`
  const maxTooltipId = `max-${baseTooltipId}`
  const showRange = min !== undefined && max !== undefined
  const strings = Strings()

  return (
    <Box style={{ width: '50%' }}>
      <Text
        size={100}
        variant='page'
        tone={500}
        style={{ whiteSpace: 'nowrap' }}
      >
        {label}
      </Text>
      <Text
        as='div'
        size={400}
        fontWeight={700}
        style={{ whiteSpace: 'nowrap' }}
      >
        {formattedValue}
        {unit && (
          <Text as='span' size={100} variant='page' tone={500}>
            {unit}
          </Text>
        )}
      </Text>

      {showRange && (
        <>
          <FlexV2 alignMainAxis='space-between' axisGap={400}>
            <FlexV2 alignCrossAxis='center'>
              <Icon
                name='arrow_downward'
                size={200}
                variant='page'
                tone={400}
                data-tooltip-id={minTooltipId}
              />
              <Text size={75} variant='page' tone={400}>
                {formattedMin}
              </Text>
            </FlexV2>

            <FlexV2 alignCrossAxis='center'>
              <Icon
                name='arrow_upward'
                size={200}
                variant='page'
                tone={400}
                data-tooltip-id={maxTooltipId}
              />
              <Text size={75} variant='page' tone={400}>
                {formattedMax}
              </Text>
            </FlexV2>
          </FlexV2>

          <Tooltip
            id={minTooltipId}
            content={strings.minValueTooltip}
            float={true}
            place='bottom'
            variant='light'
            className='metric-tooltip'
          />

          <Tooltip
            id={maxTooltipId}
            content={strings.maxValueTooltip}
            float={true}
            variant='light'
            className='metric-tooltip'
            place='bottom'
          />
        </>
      )}
    </Box>
  )
}

export default MetricValue
